import styled from 'styled-components'
import { Card } from 'components/forms'
import { MEDIA } from 'utils/constants'

const { DESKTOP_UP, MOBILE } = MEDIA

export const Container = styled.div`
  width: 100%;
  margin-bottom: 24px;

  @media screen and ${DESKTOP_UP} {
    max-width: 80%;
  }
`

export const Title = styled.h3`
  font-family: var(--primary-font);
  font-size: 18px;
  font-weight: 600;
  color: var(--gray-2);
  margin-bottom: 16px;
  line-height: 120%;

   @media screen and ${MOBILE} {
    font-size: 16px;
  }
`

export const PurchasedPackagesGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and ${MOBILE} {
    gap: 16px;
  }
`

export const PurchasedPackageCard = styled(Card)`
  padding: 16px;
  border-radius: 24px;
  border: ${({ isSelected }) => isSelected ? '1px solid var(--cobasi-blue-light-9)' : '1px solid var(--silver)'};
  cursor: pointer;
  position: relative;
  min-height: 120px;
  opacity: 1;
  pointer-events: initial;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${props => !props.active && 'pointer-events: none; cursor: default; background: var(--bleached-silk);'}
`

export const PetContainer = styled.div`
  display: flex;
  gap: 16px;
`

export const PurchasedPackagePetAndStatusInfo = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
`

export const PurchasedPackageInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 16px;
  align-items: center;
  background: var(--pet-anjo-lighter-blue);
  border-radius: 12px;
  min-width: 120px;
`

export const PetPhoto = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  object-fit: cover;
  flex-shrink: 0;
  align-self: flex-start;
`

export const PetInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
  min-width: 0;
`

export const PurchasedPackageName = styled.span`
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 600;
  color: var(--gray-2);
  line-height: 150%;
  white-space: nowrap;
`

export const PetName = styled.span`
  font-family: var(--primary-font);
  font-size: 16px;
  font-weight: 600;
  color: var(--gray-2);
  line-height: 150%;
  white-space: nowrap;
`

export const PurchasedPackageDescription = styled.p`
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  color: var(--gray-5);
  margin: 0;
  line-height: 17px;
`

export const PackageQuantity = styled.span`
  color: var(--cobasi-blue-light-8);
  font-size: 16px;
  font-weight: 600;
  line-height: 120%;
`

export const StatusBadge = styled.div`
  background: ${({ status }) => status === 'expiringSoon' ? 'var(--clean-gray)' : 'var(--pet-anjo-light-blue)'};
  color: ${({ status }) => status === 'expiringSoon' ? 'var(--golden-yellow)' : 'var(--pet-anjo-dark-blue)'};
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 8px;
  text-align: center;
`
